<template>
    <div v-if="resetFn && saveFn && hasChanges">
        <SmuDialog :has-close-button="false" :open="isModalOpen">
            <template #title>
                {{ $t("helpers.confirm.title") }}
            </template>
            <div class="flex w-full flex-col lg:w-[35rem]">
                <span class="my-3">
                    {{ $t("helpers.confirm.unsaved_changes_content") }}
                </span>
            </div>
            <template #footerContent>
                <div class="flex flex-wrap justify-center sm:justify-end">
                    <SmuButton
                        color="secondary"
                        class="m-1"
                        data-testid="header-edit-state-dialog-continue-edit-button"
                        @click="toggleModal(false)"
                    >
                        {{ $t("helpers.buttons.continue_edit") }}
                    </SmuButton>
                    <SmuButton
                        color="danger"
                        class="m-1"
                        data-testid="header-edit-state-dialog-discard-changes-button"
                        @click="
                            toggleModal(false);
                            resetFn();
                        "
                    >
                        {{ $t("helpers.buttons.discard_changes") }}
                    </SmuButton>
                </div>
            </template>
        </SmuDialog>
        <div class="flex h-full w-full justify-between text-sm text-white">
            <div
                class="my-auto flex w-full text-left align-middle md:w-1/2 md:text-center"
            >
                <span>
                    <SmuIcon
                        type="light"
                        icon="triangle-exclamation"
                        class="mr-1"
                    />
                    <span
                        class="px-1 font-light text-wrap text-white max-sm:hidden"
                    >
                        {{ $t("helpers.common.unsaved_changes") }}
                    </span>
                </span>
            </div>
            <div
                class="mr-4 flex flex-1 items-center justify-end whitespace-nowrap"
            >
                <div class="flex space-x-2">
                    <SmuButton
                        color="secondary"
                        size="sm"
                        :disabled="isLoading"
                        data-testid="header-edit-state-discard-button"
                        @click="toggleModal(true)"
                    >
                        {{ $t("helpers.buttons.discard") }}
                    </SmuButton>
                    <SmuButton
                        color="primary"
                        size="sm"
                        :disabled="isLoading"
                        data-testid="header-edit-state-save-button"
                        @click="saveFn"
                    >
                        <template #iconLeft>
                            <div v-if="isLoading">
                                <SmuIcon
                                    type="light"
                                    icon="spinner"
                                    :spin-pulse="true"
                                />
                            </div>
                        </template>

                        {{ $t("helpers.buttons.save") }}
                    </SmuButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const { hasChanges, isLoading, isModalOpen, resetFn, saveFn, toggleModal } =
    useUnsavedChangesHeader();
</script>
